import React, { useEffect, useState } from "react";
import Header from "./homepage/Header";
import TcNav from "../components/tcs/TcNav";
import DriverNav from "../components/drivers/DriverNav";
import "../styles/homepage.css"

const PoliceStation = () => {
  const [stations, setStations] = useState([]);
  const auth = localStorage.getItem("user");
  const user = JSON.parse(auth);
  const type = user && user[0].userType;
  const getStations = async () => {
    try {
      const response = await fetch("http://localhost:8000/policestation");
      const data = await response.json();
      // Capitalize the name before setting it in the state
      const capitalizedStations = data.map((station) => ({
        ...station,
        name: station.name.toUpperCase(),
      }));
      setStations(capitalizedStations);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getStations();
  }, []);

  return (
    <div className="text-white text-center mt-5">
      {auth ? auth && (type === "admin" || type ==="super") ? <TcNav /> : <DriverNav /> : <Header />}

      {!auth && <h3 className="mt-4 mb-4">Police Stations in Chattogram</h3>}
      {auth && <h3 className="mt-5 mb-5 dummy">dummy</h3>}
      <div className="container">
        <table className="table table-bordered">
          <thead>
            <tr>
              {/* <th style={{ width: "50%" }}>ID</th> */}
              <th >Locations</th>
            </tr>
          </thead>
          <tbody>
            {stations.map((station) => (
              <tr key={station.id}>
                {/* <td>{station.id}</td> */}
                <td>{station.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PoliceStation;
